import Vue from 'vue';
import Vuelidate from 'vuelidate';

import NationwideForm from '../components/NationwideForm';

Vue.config.devtools = true;

if (typeof(Sentry) === 'object') {
    Sentry.init({
        dsn: 'https://2fb472ccf101450bb2a4bab2b526f5ac@sentry.io/1339924',
        integrations: [new Sentry.Integrations.Vue({Vue, attachProps: true})]
    });
}

Vue.use(Vuelidate);

Vue.component('nationwide-form', NationwideForm);

new Vue({
    el: '#nationwide-form',
    components: { NationwideForm }
});
